const messages = {
  error_unavailable: 'Website currently unavailable',
  error_not_found: 'Page not found'
}

export default {
  messages
}
